<script>
import { VBTooltip } from 'bootstrap-vue';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    form: {
      required: true,
    },

    name: {
      requried: true,
    },

    action: {
      requried: true,
    },

    button: {
      requried: true,
    },

    description: {
      required: true,
    },

    action_content: {
      required: true,
    },

    hide_labels: {
      required: true,
    },
  },

  data: () => ({
    tooltipActions: {
      html: true,
      title: '<a target="_blank" rel="noopener noreferrer" style="color: #fff" href="https://salesflowcrm.movidesk.com/kb/article/405272/como-fazer-um-redirecionamento-de-uma-landing-page-apos-o-envio-">Clique para saber mais</a>',
    },
    tooltipLabels: {
      html: true,
      title: '<a target="_blank" rel="noopener noreferrer" style="color: #fff" href="https://salesflowcrm.movidesk.com/kb/article/405401/o-que-e-placeholder-e-mascara-para-que-servem">Clique para saber mais</a>',
    },
  }),

  computed: {
    actions () {
      return [
        {
          text: this.__('Selecione'),
          value: null,
        },
        {
          text: this.__('Redirecionar para uma página'),
          value: 'redirect',
        },
        {
          text: this.__('Exibir um texto / HTML'),
          value: 'message',
        },
      ];
    },

    actionLabel () {
      const {
        action,
      } = this;

      return action === 'redirect' ? 'Link para o redirecionamento' : 'Texto/HTML da ação';
    },
  },
};
</script>

<template>
  <div
    class="form-builder-settings"
  >
    <h5
      class="form-builder-settings__title pb-20px sticky-top"
    >
      {{ __('Opções do Formulário') }}
    </h5>

    <div
      class="form-builder-settings__body"
    >
      <div
        class="form-group"
      >
        <label
          class="form-builder-settings__input"
        >
          {{ __('Nome do Formulário') }}
        </label>

        <input
          type="text"
          name="rules"
          :value="name"
          class="form-control"
          @input="$emit('update:name', $event.target.value)"
        >
      </div>

      <div
        class="form-group"
      >
        <label
          class="form-builder-settings__input"
        >
          {{ __('Descrição do Formulário') }}
        </label>

        <input
          type="text"
          name="rules"
          class="form-control"
          :value="description"
          @input="$emit('update:description', $event.target.value)"
        >
      </div>

      <div
        class="form-group"
      >
        <label
          class="form-builder-settings__input"
        >
          {{ __('Texto do botão do formulário') }}
        </label>

        <input
          type="text"
          name="rules"
          :value="button"
          class="form-control"
          @input="$emit('update:button', $event.target.value)"
        >
      </div>

      <div
        class="form-group"
      >
        <label
          class="form-builder-settings__input"
        >
          {{ __('Categorias') }}
        </label>

        <InputCategory
          type="form"
          :model="form.id"
          class="form-control"
          :value="form.categories"
        />
      </div>

      <div
        class="form-group"
      >
        <label
          class="form-builder-settings__input"
        >
          {{ __('Ação após o envio') }}

          <a
            target="_blank"
            rel="noopener noreferrer"
            v-b-tooltip.bottom="tooltipActions"
            class="form-builder-settings__info"
            href="https://salesflowcrm.movidesk.com/kb/article/405272/como-fazer-um-redirecionamento-de-uma-landing-page-apos-o-envio-"
          >
            <span
              class="form-builder-settings__info-trigger"
            >
              ?
            </span>
          </a>
        </label>

        <select
          required
          autofocus
          name="type"
          :value="action"
          class="form-control"
          @input="$emit('update:action', $event.target.value)"
        >
          <option
            :key="action.value"
            v-text="action.text"
            :value="action.value"
            v-for="action in actions"
          />
        </select>
      </div>

      <div
        class="form-group"
        v-if="action"
      >
        <label
          class="form-builder-settings__input"
        >
          {{ actionLabel }}
        </label>

        <input
          type="url"
          name="rules"
          class="form-control"
          :value="action_content"
          v-if="action === 'redirect'"
          @input="$emit('update:action_content', $event.target.value)"
        >

        <textarea
          v-else
          rows="5"
          name="rules"
          class="form-control"
          :value="action_content"
          @input="$emit('update:action_content', $event.target.value)"
        />
      </div>

      <div
        class="form-group"
      >
        <label
          class="form-builder-settings__checkbox"
        >
          <input
            type="checkbox"
            :checked="hide_labels"
            @click="$emit('update:hide_labels', ! hide_labels)"
          >

          {{ __('Não exibir rótulos (labels)') }}

          <a
            target="_blank"
            rel="noopener noreferrer"
            v-b-tooltip.bottom="tooltipLabels"
            class="form-builder-settings__info"
            href="https://salesflowcrm.movidesk.com/kb/article/405401/o-que-e-placeholder-e-mascara-para-que-servem"
          >
            <span
              class="form-builder-settings__info-trigger"
            >
              ?
            </span>
          </a>
        </label>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '../../../sass/variables';

  .form-builder-settings {
    width: 100%;
    max-height: 100%;

    &__title {
      height: 40px;
      display: flex;
      font-size: .8rem;
      font-weight: 400;
      text-align: left;
      margin-top: 10px;
      line-height: 15px;
      color: #857a98;
      position: relative;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      font-family: $input-font-family;
    }

    &__input {
      width: 100%
    }

    &__checkbox {
      display: flex;
      cursor: pointer;
      align-items: center;

      & > :first-child {
        margin-right: 4px;
      }
    }

    &__info {
      width: 37px;
      cursor: pointer;
      margin-left: 4px;
      display: inline-block;

      &:hover {
        text-decoration: none !important;
      }

      &-trigger {
        width: 12px;
        color: $white;
        display: flex;
        font-size: 9px;
        font-weight: 500;
        align-items: center;
        border-radius: 14px;
        justify-content: center;
        background-color: $gray-light-2;
        font-family: $font-family-sans-serif;
      }
    }
  }
</style>
